import UniDatePicker from './UniDatePicker.vue'
export default UniDatePicker



// WEBPACK FOOTER //
// ./src/components/uniWidgets/UniDatePicker/index.js